import { Box } from '@wix/design-system';
import {
  DEFAULT_PURCHASE_CYCLE,
  getStudioStyling,
  ProductHat,
  useAnonymous,
  useProductHat,
} from '@wix/package-picker-shared-studio';
import {
  FeaturesGrid as PlatformFeaturesGrid,
  Price,
} from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { SelectButton } from '../SelectButton';

interface FeaturesGridProductHeaderProps {
  productId: string;
}

export const FeaturesGridProductHeader = ({
  productId,
}: FeaturesGridProductHeaderProps) => {
  const { isAnonymous } = useAnonymous();
  const { data: product, isLoading } =
    StudioPackagePickerModule.SDK.studioOfferingApiClient.hooks.useFetchProduct(
      {
        productId,
      },
    );

  const { isRecommended, isEnterprise, name } = product ?? {};

  const { colors } = getStudioStyling();
  const { hasHat } = useProductHat({ productId });

  if (isLoading) {
    return null;
  }

  return (
    <PlatformFeaturesGrid.Header.Cell
      borderTop={!hasHat ? `3px solid ${colors.borderTop}` : undefined}
      gap="SP1"
    >
      <Box height="30px" marginTop="-28px">
        {hasHat && <ProductHat productId={productId} />}
      </Box>
      <Box align="center" marginTop="SP2">
        <PlatformFeaturesGrid.Header.Title title={name ?? ''} size="small" />
      </Box>
      <Box visibility={isEnterprise ? 'hidden' : 'visible'}>
        <Price
          productId={productId}
          cycle={DEFAULT_PURCHASE_CYCLE}
          display={{ hideZeroDecimals: true, inline: false, size: 'tiny' }}
        />
      </Box>
      {!isAnonymous && (
        <Box align="center" width="100%" marginBottom="SP3" marginTop="SP1">
          <Box width="90%" align="center">
            <SelectButton
              filled={isRecommended}
              productId={productId}
              source="table"
            />
          </Box>
        </Box>
      )}
    </PlatformFeaturesGrid.Header.Cell>
  );
};
